/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUnitRequest,
  ErrorResponse,
  Unit,
} from '../models/index';
import {
    CreateUnitRequestFromJSON,
    CreateUnitRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UnitFromJSON,
    UnitToJSON,
} from '../models/index';

export interface CreateUnitOperationRequest {
    createUnitRequest: CreateUnitRequest;
}

export interface DeleteUnitRequest {
    id: string;
}

export interface GetAllUnitsRequest {
    projectId?: string;
    status?: string;
}

export interface GetUnitByIdRequest {
    id: string;
}

export interface UpdateUnitRequest {
    id: string;
    createUnitRequest: CreateUnitRequest;
}

/**
 * 
 */
export class UnitsApi extends runtime.BaseAPI {

    /**
     * Create a new unit
     * Create a new unit
     */
    async createUnitRaw(requestParameters: CreateUnitOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Unit>> {
        if (requestParameters['createUnitRequest'] == null) {
            throw new runtime.RequiredError(
                'createUnitRequest',
                'Required parameter "createUnitRequest" was null or undefined when calling createUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/units`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUnitRequestToJSON(requestParameters['createUnitRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnitFromJSON(jsonValue));
    }

    /**
     * Create a new unit
     * Create a new unit
     */
    async createUnit(requestParameters: CreateUnitOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Unit> {
        const response = await this.createUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a unit
     * Delete unit
     */
    async deleteUnitRaw(requestParameters: DeleteUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a unit
     * Delete unit
     */
    async deleteUnit(requestParameters: DeleteUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUnitRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a list of all units
     * Get all units
     */
    async getAllUnitsRaw(requestParameters: GetAllUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Unit>>> {
        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UnitFromJSON));
    }

    /**
     * Retrieve a list of all units
     * Get all units
     */
    async getAllUnits(requestParameters: GetAllUnitsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Unit>> {
        const response = await this.getAllUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a unit by its ID
     * Get unit by ID
     */
    async getUnitByIdRaw(requestParameters: GetUnitByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Unit>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUnitById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnitFromJSON(jsonValue));
    }

    /**
     * Retrieve a unit by its ID
     * Get unit by ID
     */
    async getUnitById(requestParameters: GetUnitByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Unit> {
        const response = await this.getUnitByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing unit
     * Update unit
     */
    async updateUnitRaw(requestParameters: UpdateUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Unit>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUnit().'
            );
        }

        if (requestParameters['createUnitRequest'] == null) {
            throw new runtime.RequiredError(
                'createUnitRequest',
                'Required parameter "createUnitRequest" was null or undefined when calling updateUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUnitRequestToJSON(requestParameters['createUnitRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnitFromJSON(jsonValue));
    }

    /**
     * Update an existing unit
     * Update unit
     */
    async updateUnit(requestParameters: UpdateUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Unit> {
        const response = await this.updateUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
